import React, { useEffect, useState } from 'react';
import TextInput from '../Common/TextInput';
import CallOut from '../Common/CallOut';
import Notification from '../Common/Notification';
import ActivityLoader from '../Common/ActivityLoader';
import { useConfig } from '../../DataStore/ConfigContext';
import { useFeesBalance } from '../../DataStore/FeesBalanceContext';
import ajaxStudent from '../../util/remote/ajaxStudent';

const SyncBalances = () => {
 const { getFeesBalances } = useFeesBalance();
 const { classes, getClasses } = useConfig();
 const [notify, setNotify] = useState(null);
 const [loading, setLoading] = useState(false);
 const [classId, setClassId] = useState(null);

 useEffect(() => {
     getClasses();
   }, []);
 


  useEffect(() => {
    if (notify) {
      const timeout = setTimeout(() => setNotify(null), 5000);
      return () => clearTimeout(timeout);
    }
  }, [notify]);


  const classOptions = Array.isArray(classes)
    ? classes.map(cls => ({
        label: `${cls.class_name}`,
        value: cls.class_id,
      }))
    : [];



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!classId) {
      setNotify(<Notification type="danger" message="Please select class and try again." />);
      return;
    }
    setLoading(true);
    const payload = {
        class_id: classId,
    };
    const response = await ajaxStudent.syncFeesBalances(payload);
    setLoading(false);
    if (response.status === "OK") {
      setNotify(<Notification type="success" message={response.message} />);
      getFeesBalances(true);
    } else {
      setNotify(<Notification type="danger" message={response.message} />);
    }
  };

  
  return (
    <div className="card-body">
      <CallOut
        title="Sync Fees Balances"
        description="Sync student fees balances from the accounting system. This will update the balances for all students in the selected class."
      />
      {notify}

      <form className="form-horizontal" onSubmit={handleSubmit}>

            <TextInput
                label="Class"
                placeholder='Select class'
                type="select"
                options={classOptions}
                onChange={(item) => setClassId(item.value)}
                wrap
                required
            />


       
        <div className="text-right">
          {!loading && <button type="submit" className="btn btn-lg btn-primary">Sync Balances</button>}
          {loading && <ActivityLoader />}
        </div>
      </form>
    </div>
  );
};

export default SyncBalances;
